'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var notRequiredCache = void 0;

var notRequired = exports.notRequired = function notRequired(propType) {
  if (propType == null) return propType;
  notRequiredCache = notRequiredCache || new WeakMap();
  if (!notRequiredCache.has(propType)) {
    var notRequiredPropType = function notRequiredPropType(props, propName) {
      for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      if (props[propName] == null) return null;
      return propType.apply(undefined, [props, propName].concat(rest));
    };
    notRequiredPropType.getType = propType.getType;

    if (propType.__INTROSPECTION__) {
      notRequiredPropType.__INTROSPECTION__ = _extends({}, propType.__INTROSPECTION__, {
        isRequired: false
      });
    }
    notRequiredCache.set(propType, notRequiredPropType);
  }
  return notRequiredCache.get(propType);
};

var hiddenCache = void 0;

var hidden = exports.hidden = function hidden(propType) {
  if (propType == null) return propType;
  hiddenCache = hiddenCache || new WeakMap();
  if (!hiddenCache.has(propType)) {
    var hiddenPropType = function hiddenPropType() {
      return propType.apply(undefined, arguments);
    };
    hiddenPropType.getType = propType.getType;

    if (propType.__INTROSPECTION__) {
      hiddenPropType.__INTROSPECTION__ = _extends({}, propType.__INTROSPECTION__, {
        isHidden: true
      });
    } else {
      hiddenPropType.__INTROSPECTION__ = { isHidden: true };
    }
    hiddenCache.set(propType, hiddenPropType);
  }
  return hiddenCache.get(propType);
};